<ion-label>
  <ng-content></ng-content>
  <span><ng-content select="[secondary]"></ng-content></span>
</ion-label>
